export function downloadBlob(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export function validateFile(file: File): { isValid: boolean; error?: string } {
  const MAX_SIZE = 50 * 1024 * 1024; // 50MB
  const SUPPORTED_TYPES = [
    'application/pdf',
    'text/plain',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/markdown',
  ];

  if (!file) {
    return { isValid: false, error: 'Aucun fichier sélectionné' };
  }

  if (file.size > MAX_SIZE) {
    const sizeMB = Math.round(file.size / (1024 * 1024));
    return {
      isValid: false,
      error: `Fichier trop volumineux (${sizeMB}MB). Taille maximale: 50MB`,
    };
  }

  if (!SUPPORTED_TYPES.includes(file.type)) {
    return {
      isValid: false,
      error: `Type de fichier non supporté: ${file.type}. Types supportés: PDF, TXT, DOC, DOCX, MD`,
    };
  }

  return { isValid: true };
}
